/**
 * Username used by password-confirm modals (Quick Sync, Schedule Quick Actions).
 * Prefer localStorage; fall back to the JWT payload when login() never wrote it.
 */
export function getStoredUsername() {
  const raw = localStorage.getItem('username');
  if (raw) {
    try {
      const parsed = JSON.parse(raw);
      if (typeof parsed === 'string' && parsed) return parsed;
    } catch {
      if (raw) return raw;
    }
  }

  const token = localStorage.getItem('token');
  if (!token) return '';

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const name = payload?.user?.username;
    if (typeof name === 'string' && name) {
      localStorage.setItem('username', JSON.stringify(name));
      return name;
    }
  } catch {
    // ignore malformed tokens
  }

  return '';
}
